import styled from 'styled-components';

export const AboutIntroBlockWrapper = styled.section`
  max-width: 1170px;
  position: relative;
  margin: 0px auto;
  background: #fff;
  padding-top: 100px;
  padding-bottom: 100px;
  display: none;
  &.isabout-page {
    display: block;
  }
  @media (max-width: 1200px) {
    max-width: 1100px;
    padding-left: 15px;
    padding-right: 15px;
  }
  @media (max-width: 992px) {
    max-width: 960px;
    padding-top: 50px;
    padding-bottom: 50px;
  }
  @media (max-width: 768px) {
    max-width: 720px;
  }
  @media (max-width: 576px) {
    max-width: 540px;
  }
`;
export const AboutIntroBlockRow = styled.div`
  display: flex;
  flex-direction: row;
  column-gap: 30px;
  @media (max-width: 992px) {
    flex-direction: column;
    row-gap: 20px;
  }
`;
export const AboutIntroBlockTitle = styled.h2`
  font-size: 30px;
  line-height: 42px;
  color: #000;
  max-width: 370px;
  margin: 0px;
  @media (max-width: 1460px) {
    font-size: 24px;
  }
  @media (max-width: 1300px) {
    font-size: 22px;
    line-height: 35px;
  }
  @media (max-width: 992px) {
    max-width: 100%;
    font-size: 20px;
    line-height: 32px;
  }
`;
export const AboutIntroDescriptionWrapper = styled.div`
  display: flex;
  flex-direction: row;
  column-gap: 30px;
  max-width: 1072px;
  @media (max-width: 767px) {
    max-width: 100%;
    flex-direction: column;
    row-gap: 15px;
  }
`;
export const AboutIntroDescription = styled.p`
  max-width: 370px;
  font-size: 14px;
  line-height: 20px;
  color: #898989;
  margin-bottom: 0px;
  @media (min-width:1300px){
    font-size: 20px;
    line-height: 30px;
  }
  @media (max-width: 992px) {
    max-width: 50%;
  }
  @media (max-width: 767px) {
    max-width: 100%;
  }
`;
